// removed by extract-text-webpack-plugin
module.exports = {"dialog":"_2joJJzskrNlGCKuiBr_Nae","dialog-title":"Qd1wOePWHX2bcrT2J08dX","dialog-message":"_3NVoyUcaNUjKkTkfR5VO6t","btns":"_38CVLkWw6mLBqQMnP8MAsG","btn":"_2gDHByuMz003pHS72kJsiI"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/v2/molecules/Dialog/style.module.css
// module id = 481
// module chunks = 38